import { inject, Injectable } from '@angular/core';
import { Params } from '@angular/router';
import { PartSearchService } from '@lib-services/part-search.service';

@Injectable({
    providedIn: 'root'
})
export class ReportQueryService {

    partSearchService = inject(PartSearchService);

    createSearchParams(query: Record<string, string | null>): Params | null {

        const size = Object.keys(query).length;
        if (!size) {
            return null;
        }

        const queryParams: Params = {
            sortBy: 'dateFrom:ASC'
        };
        Object.entries(query).forEach(([key, value]) => {

            let params: string[] = [];
            let filterValue;

            switch (key) {
            case 'group':
                params = String(value).split(',').map((el: string) => el.trim());
                filterValue = `$in:${this.partSearchService.createMultiParams(params).join()}`;
                key = `filter.${key}`;
                break;
            case 'status':
                params = String(value).split(',').map((el: string) => el.trim());
                filterValue = `$in:${this.partSearchService.createMultiParams(params).join()}`;
                key = `filter.${key}`;
                break;
            case 'dateFrom':
                key = 'filter.dateFrom';
                filterValue = `$btw:${value}`;
                break;
            default:
                filterValue = `${value}`;
            }
            queryParams[key] = filterValue;

        });

        return queryParams;
    }

}
